import { useSelector } from '@ufc/core'
import { selectUserRoleType } from '../../store/auth.selectors'
import { isReadOnlyAdminRole } from '../../domain/utils/role-access'

/**
 * Returns true when the current user's role has read-only access to the admin
 * portal (currently the IT role). UI components use this to hide create / edit /
 * delete / approve / reject controls without restricting route access.
 */
export function useIsAdminReadOnly(): boolean {
  const roleType = useSelector(selectUserRoleType)
  return isReadOnlyAdminRole(roleType)
}
